export class GlobalConstants {
    public static PREFIX_GOALIE = "00-";
    public static PREFIX_PLAYER = "01-";
    public static PREFIX_GUEST_GOALIE = "GG-";
    // public static PREFIX_GASTA_PLAYER = "GP-";
}


// WEBPACK FOOTER //
// ./src/models/global-constants.ts